export * from "./text.component";
